import { EventFormAnswerFilters } from "@ac-expo/api-types";

export const eventFormAnswersQueryKeys = {
  all: ["event-form-answers"] as const,
  userAnswers: (eventId: string, filters?: EventFormAnswerFilters) =>
    [...eventFormAnswersQueryKeys.all, "user-answers", eventId, filters] as const,
  export: (eventId: string) => [...eventFormAnswersQueryKeys.all, "export", eventId] as const,
};
